<template>
    <div id="content">
        <el-row :gutter="20" class="box-flex">
            <!-- 系统公告 -->
            <el-col :span="12">
                <div class="home-title">系统公告</div>
                <el-card class="home-container">
                    <div class="card-body">
                        <div v-html="noticeContent"></div>
                    </div>
                </el-card>
            </el-col>

            <!-- 意见反馈 -->
            <el-col :span="12">
                <div class="home-title">意见反馈</div>
                <el-card class="home-container">
                    <div class="card-body card-fb">
                        <el-row :gutter="20" class="box-flex">
                            <el-col :span="20">
                                <el-input type="textarea" placeholder="您可以输入对系统的优化建议与需求，IT管理员会通过企业微信与您联系！" v-model="feedbackParams.remark"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-button type="primary" size="small" @click="submitFeedback()">提交</el-button>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 我的单据 -->
        <!-- <div class="home-title">我的单据</div>
        <el-card class="home-container">
            <div class="card-body">
                <el-table :data="latestOrdersList" max-height="350">
                    <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
                    <el-table-column label="单据分类" align="center" min-width="20" prop="type"></el-table-column>
                    <el-table-column label="单据号" align="center" min-width="30" prop="no"></el-table-column>
                    <el-table-column label="处理时间" align="center" min-width="30" prop="operateTime">
                        <template slot-scope="scope">
                            <div>{{ scope.row.operateTime | formatTime }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="当前状态" align="center" min-width="20" prop="currentStatus"></el-table-column>
                </el-table>
            </div>
        </el-card> -->
		
		<!-- 我的通知 -->
		<div class="home-title mc-flex mc-flex-justify-between">
			<div>我的通知</div>
			<div>
				<el-button type="text" @click="todoDialogOpen()">查看更多 >></el-button>
			</div>
		</div>
		<el-card class="home-container">
			<div class="card-body">
				<el-table :data="todoList" max-height="350">
					<el-table-column label="通知时间" align="center" min-width="30" prop="createTime">
						<template slot-scope="scope">
							<div>{{ scope.row.createTime | formatDay }}</div>
						</template>
					</el-table-column>
					<el-table-column label="菜单路径" align="center" min-width="30" prop="path"></el-table-column>
					<el-table-column label="通知内容" align="center" min-width="100" prop="context">
						<template slot-scope="scope">
              <div v-if="scope.row.path=='应收管理/票据管理'">
                <el-link type="primary" :href="'/returnedMoneyNote?dimNoteNumber='+scope.row.refCode">{{ scope.row.context }}</el-link>
              </div>
              <div v-else>
                {{ scope.row.context }}
              </div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-card>
		
		<!-- 我的通知-查看更多 -->
		<el-dialog title="我的通知" center :visible.sync="todoDialogFlag" top="10vh" width="70%">
			<!-- 查询 -->
			<el-form :inline="true" size="small">
				<el-form-item>
					<el-input v-model="todoParams.key"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="queryTodoPageTODO()">查询</el-button>
				</el-form-item>
			</el-form>
			<!-- 列表 -->
			<el-table :data="todoMoreList" stripe border class="table-list">
				<el-table-column label="通知时间" align="center" min-width="30" prop="createTime">
					<template slot-scope="scope">
						<div>{{ scope.row.createTime | formatDay }}</div>
					</template>
				</el-table-column>
				<el-table-column label="菜单路径" align="center" min-width="30" prop="path"></el-table-column>
				<el-table-column label="通知内容" align="center" min-width="100" prop="context">
					<template slot-scope="scope">
						<div v-if="scope.row.path=='应收管理/票据管理'">
							<el-link type="primary" :href="'/returnedMoneyNote?dimNoteNumber='+scope.row.refCode">{{ scope.row.context }}</el-link>
						</div>
            <div v-else>
              {{ scope.row.context }}
            </div>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="pagination-wrapper" v-if="todoMoreList.length>0">
				<el-pagination
					@current-change="(value) => {handleCurrentChange(value, 'todoParams')}"
					:page-size="todoParams.pageSize"
					:current-page.sync=todoParams.pageNo
					background
					layout="total, prev, pager, next"
					:total="todoParams.pageTotal">
				</el-pagination>
			</div>
		</el-dialog>


        <!-- SP采购订单日志 -->
        <div v-if="!$store.state.shouldHideReturnFields" class="home-title">SP采购订单日志</div>
        <el-card v-if="!$store.state.shouldHideReturnFields" class="home-container">
            <div class="card-body">
                <div class="form-control">
                    <el-input v-model="purchaseorderlogParams.purchaseNo" size="small" placeholder="请输入采购订单号查询" @keyup.enter.native="queryPurchaseorderlogList()"></el-input>
                    <el-button type="primary" size="small" @click="queryPurchaseorderlogList()">提交</el-button>
                </div>
                <el-table :data="purchaseorderlogList">
                    <el-table-column type="index" label="序号" width="80" align="center"
                        :index="(index)=>{return (index+1) + (purchaseorderlogParams.pageNo-1)*purchaseorderlogParams.pageSize}">
                    </el-table-column>
                    <el-table-column label="操作场景" align="center" min-width="20" prop="operateType"></el-table-column>
                    <el-table-column label="日志描述" min-width="80" prop="operateDescription" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作人" align="center" min-width="20" prop="operateUser"></el-table-column>
                    <el-table-column label="操作时间" align="center" min-width="30" prop="operateTime">
                        <template slot-scope="scope">
                            <div>{{ scope.row.operateTime | formatTime }}</div>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="pagination-wrapper" v-if="purchaseorderlogList.length>0">
                    <el-pagination
                        @current-change="(value) => {handleCurrentChange(value, 'purchaseorderlogParams')}"
                        @size-change="(value) => {handleSizeChange(value, 'purchaseorderlogParams')}"
                        :page-size="purchaseorderlogParams.pageSize"
                        :page-sizes="[10,50,100,500,1000]"
                        :current-page.sync=purchaseorderlogParams.pageNo
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="purchaseorderlogParams.pageTotal">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <!-- 学习中心 -->
        <!-- <div class="home-title">学习中心</div>
        <el-card class="home-container">
            <div class="card-body">
                <div class="form-control">
                    <el-input v-model="learnFileParams.text" size="small" placeholder="请输入关键词检索" @keyup.enter.native="queryLearnFileList()"></el-input>
                    <el-button type="primary" size="small" @click="queryLearnFileList()">提交</el-button>
                </div>
                <el-table :data="learnFileList">
                    <el-table-column type="index" label="序号" width="80" align="center"
                        :index="(index)=>{return (index+1) + (learnFileParams.pageNo-1)*learnFileParams.pageSize}">
                    </el-table-column>
                    <el-table-column label="业务分类" align="center" min-width="20" prop="typeName"></el-table-column>
                    <el-table-column label="标题" min-width="30" prop="title" show-overflow-tooltip></el-table-column>
                    <el-table-column label="查看内容" min-width="50" prop="fileUrl" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                <el-link type="primary" @click="viewLearnFile(scope.row.fileUrl)">{{ scope.row.fileUrl }}</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-wrapper" v-if="learnFileList.length>0">
                    <el-pagination
                        @current-change="(value) => {handleCurrentChange(value, 'learnFileParams')}"
                        @size-change="(value) => {handleSizeChange(value, 'learnFileParams')}"
                        :page-size="learnFileParams.pageSize"
                        :page-sizes="[10,50,100,500,1000]"
                        :current-page.sync=learnFileParams.pageNo
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="learnFileParams.pageTotal">
                    </el-pagination>
                </div>
            </div>
        </el-card> -->
    </div>
</template>
<script>
import Moment from "moment";
export default {
name: "home",
data() {
    return {
        //系统公告
        noticeContent: '',
        //意见反馈
        feedbackParams: {
            remark: '',
        },
        //我的单据
        // latestOrdersList: [],
		//我的通知
		todoParams: {
			key: '',
			pageNo: 1,
			pageSize: 10,
			pageTotal: 0,
		},
		todoList: [],
		todoMoreList: [],
		todoDialogFlag: false,
        //SP采购订单日志
        purchaseorderlogParams: {
            purchaseNo: '',
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
        },
        purchaseorderlogList: [],
        //学习中心
        // learnFileParams: {
        //     text: '',
        //     pageNo: 1,
        //     pageSize: 10,
        //     pageTotal: 0,
        // },
        // learnFileList: [],
      roleIdList: JSON.parse(sessionStorage.getItem("ROLEIDLIST")),
    };
},
filters: {
    formatTime(time) {
      return time ? Moment(time).format("YYYY年MM月DD日 HH:mm:ss") : "";
    },
	formatDay(time){
		return time ? Moment(time).format("YYYY-MM-DD") : "";
	}
},
created() {
    this.getBaseParams();
	this.todoPageTODO(true);
    // this.getLatestOrdersByOperator();
    // this.getLearnFileList();
},
methods: {
    // 系统公告
    async getBaseParams(){
        let res = await this.$api.getBaseParams({
            typeCode:"bms_web",
            paramCode:"system_announcement"
        })
        if(res.code===200){
            if(res.result && res.result[0]){
                this.noticeContent = res.result[0].columnValue;
            };
        };
    },
    // 意见反馈
    async submitFeedback(){
        if(!this.feedbackParams.remark){
            this.$msg.warn('请输入您的建议');
            return false;
        };

        let res = await this.$api.baseSubmitFeedback({ ...this.feedbackParams })
        if(res.code===200){
            this.feedbackParams.remark = '';
            this.$msg.success('成功');
        };
    },
    // 我的单据
    // async getLatestOrdersByOperator(){
    //     let res = await this.$api.getLatestOrdersByOperator()
    //     if(res.code===200){
    //         this.latestOrdersList = res.result;
    //     };
    // },
	// 我的通知-查询
	queryTodoPageTODO(){
		this.todoParams.pageNo = 1;
		this.todoPageTODO();
	},
	// 我的通知-获取列表
	async todoPageTODO(flag){
		let params = { ...this.todoParams };
		if(flag){
			params = {
				pageNo: 1,
				pageSize: 3,
			}
		}
		let res = await this.$api.todoPageTODO(params);
		if(res.code===200){
			if(flag){
				this.todoList = res.result.list;
			}else{
				this.todoMoreList = res.result.list;
				this.todoParams.pageTotal = res.result.totalCount;
			}
		};
	},
	// 我的通知-打开弹窗
	todoDialogOpen(){
		this.todoDialogFlag = true;
		if(this.todoMoreList.length === 0){
			this.todoPageTODO();
		}
	},
    // SP采购订单日志-查询
    queryPurchaseorderlogList(){
        if(this.purchaseorderlogParams.purchaseNo){
            this.purchaseorderlogParams.pageNo = 1;
            this.getPurchaseorderlogList();
        }else{
            this.$msg.warn('请输入采购订单号');
        };
    },
    // SP采购订单日志-请求
    async getPurchaseorderlogList(){
        let res = await this.$api.getPurchaseorderlogList({ ...this.purchaseorderlogParams })
        if(res.code===200){
            this.purchaseorderlogList = res.result.list;
            this.purchaseorderlogParams.pageTotal = res.result.totalCount;
        };
    },
	/*
    // 学习中心-查询
    queryLearnFileList(){
        this.learnFileParams.pageNo = 1;
        this.getLearnFileList();
    },
    // 学习中心-请求
    async getLearnFileList(){
        let res = await this.$api.getLearnFileList({ ...this.learnFileParams })
        if(res.code===200){
            this.learnFileList = res.result.list;
            this.learnFileParams.pageTotal = res.result.totalCount;
        };
    },
    // 学习中心-查看文件
    async viewLearnFile(url){
        window.open('https://qxm.oss-cn-shenzhen.aliyuncs.com/'+url);
    },
	*/
    // 分页-切换
    handleCurrentChange(val, key){
        switch (key) {
            //SP采购订单日志
            case 'purchaseorderlogParams':
                this.purchaseorderlogParams.pageNo = val;
                this.getPurchaseorderlogList();
                break;
            //学习中心
            case 'learnFileParams':
                this.learnFileParams.pageNo = val;
                this.getLearnFileList();
                break;
            //我的通知
            case 'todoParams':
                this.todoParams.pageNo = val;
                this.todoPageTODO();
                break;
        };
    },
    // 分页-大小
    handleSizeChange(val, key){
        switch (key) {
            //SP采购订单日志
            case 'purchaseorderlogParams':
                this.purchaseorderlogParams.pageSize = val;
                this.purchaseorderlogParams.pageNo = 1;
                this.getPurchaseorderlogList();
                break;
            //学习中心
            case 'learnFileParams':
                this.learnFileParams.pageSize = val;
                this.learnFileParams.pageNo = 1;
                this.getLearnFileList();
                break;
        };
    },
}
};
</script>
<style scoped lang="less">
.home-title {
    height: 40px;
    line-height: 40px;
    font-weight: 700;
    font-size: 19px;
    color: #005BF5;
}
.home-container {
    margin-bottom: 20px;
    border-color: #DCDFE6;
    // border-radius: 0;
    box-shadow: 0px 0px 5px rgba(0,0,0,0.2);
    /deep/.el-card__body {
        box-sizing: border-box;
        height: 100%;
    }
    .card-body {
        font-size: 16px;
        /deep/p {
          margin: 0;
        }
        /deep/.el-table {
            .el-table__header-wrapper {
                th {
                    height: 30px !important;
                    padding: 0;
                    background-color: #C8DAF7;
                    border-bottom: none;
                    font-size: 13px;
                    color: #333;
                }
            }
            .el-table__body-wrapper {
                td {
                    border-bottom: none;
                    font-size: 13px;
                    color: #333;
                }
            }
            &::before {
                display: none;
            }
            &.medium-table {
                .el-table__header-wrapper {
                    th {
                        font-size: 15px;
                    }
                }
                .el-table__body-wrapper {
                    td {
                        font-size: 15px;
                    }
                }
            }
        }
        &.card-fb {
            height: 100%;
            .box-flex {
                height: 100%;
                .el-col {
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                }
            }
            /deep/.el-textarea {
                height: 100%;
                .el-textarea__inner {
                    min-height: 110px !important;
                    height: 100%;
                    resize: none;
                    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
                    border-radius: 0;
                }
            }
        }
    }
    .form-control {
        margin-bottom: 15px;
        .el-input {
            width: 300px;
            margin-right: 15px;
        }
    }
}
.box-flex {
    display: flex;
    .el-col {
        display: flex;
        flex-direction: column;
    }
    .home-container {
        flex-grow: 1;
    }
}
.pagination-wrapper {
    padding-top: 20px;
    .el-pagination {
        text-align: right;
    }
}
</style>
